import { fromJS } from 'immutable';
import { LoaderStatus } from '../common/components/CommonLoader';

const initialData = fromJS({
  userDetails: {},
  loaderStatus: LoaderStatus.IN_PROGRESS,
  items: [],
  totalItems: 0,
  pendingChangesCount: 0,
  selectedChangeRequestId: null,
});

export const FETCH_CHANGES = 'FETCH_CHANGES';
export const FETCH_CHANGES_SUCCESS = 'FETCH_CHANGES_SUCCESS';
export const FETCH_CHANGES_FAILURE = 'FETCH_CHANGES_FAILURE';
export const FETCH_CHANGES_COUNT_SUCCESS = 'FETCH_CHANGES_COUNT_SUCCESS';
export const SET_SELECTED_CHANGE_REQUEST = 'SET_SELECTED_CHANGE_REQUEST';
export const CLEAR_SELECTED_CHANGE_REQUEST = 'CLEAR_SELECTED_CHANGE_REQUEST';

// eslint-disable-next-line default-param-last
export default (state = initialData, { type, payload }) => {
  switch (type) {
    case FETCH_CHANGES:
      return state.merge({
        loaderStatus: LoaderStatus.IN_PROGRESS,
      });
    case FETCH_CHANGES_SUCCESS:
      return state.merge({
        loaderStatus: LoaderStatus.SUCCESS,
        items: payload.items,
        totalItems: payload.totalItems,
      });
    case FETCH_CHANGES_FAILURE:
      return state.merge({
        loaderStatus: LoaderStatus.NOT_PENDING,
      });
    case FETCH_CHANGES_COUNT_SUCCESS:
      return state.merge({
        totalItems: payload.totalItems,
        pendingChangesCount: payload.pendingChangesCount,
      });
    case SET_SELECTED_CHANGE_REQUEST: {
      return state.merge({
        selectedChangeRequestId: payload,
      });
    }
    case CLEAR_SELECTED_CHANGE_REQUEST:
      return state.merge({
        totalItems: 0,
        items: [],
        loaderStatus: LoaderStatus.IN_PROGRESS,
        selectedChangeRequestId: null,
      });
    default:
      return state;
  }
};
